import iconPrint from "@/img/print-icon.svg";
import { useTranslation } from "react-i18next";

import "./style.scss";

export const PrintButton = () => {
	const { t } = useTranslation();

	return (
		<button className="print-button">
			<img src={iconPrint} alt="print weather" />
			{t("print")}
		</button>
	);
};

export default PrintButton;
